import BaseDTO from '../base/BaseDTO';
import CountryLanguage from '../country-language/CountryLanguage';

export default class Country extends BaseDTO {

    public name: string | undefined;
    public depMarketName: string | undefined;
    public languages: CountryLanguage[] = [];

    constructor(data: { [key: string]: any }) {
        super(data);
        this.name = data['name'] || undefined;
        this.depMarketName = data['depMarketName'] || undefined;
        if (data['languages']) {
            this.languages = data['languages'].map((item: any) => new CountryLanguage(item));
        }
    }
}
